import Modal from "~/common/components/Modal";

export const FillmModal = ({
  onClose,
  show,
}: {
  onClose: () => void;
  show: boolean;
}) => (
  <Modal
    className="h-fit max-h-[80vh] w-auto overflow-y-auto sm:min-w-full md:min-w-[36rem]"
    titleClassName="text-2xl font-semibold w-2/3 text-gray-70"
    title="Fillm"
    show={show}
    onClose={onClose}
  >
    <div className="flex flex-col gap-4 text-gray-700">
      <p className="text-sm">
        Fillm allows patients, at their discretion, to share summaries and
        reflections related to their personal AI chat history, bringing valuable
        patient information into clinical focus.
      </p>
    </div>
  </Modal>
);
